module.exports = __webpack_public_path__ + "img/pr-2.55b9ae7a.png";